import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import SummaryTwo from './SummaryTwo';
import {
    getTruckLoad, clearAnalyzeData, getSpeed,
    subscribeAnalyzeKPI, unsubscribeAnalyzeKPI
} from '../../actions/analyze';
import { isElasticLoad, isUUID, isPlannedOrTodate } from '../../helpers/common';

class AnalyzeInfoTwo extends Component {
    constructor() {
        super();
        this.getAnalyzeInfo = this.getAnalyzeInfo.bind(this);
    }

    componentDidMount() {
        this.getAnalyzeInfo();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.params === this.props.params && prevProps.selectedPlanType === this.props.selectedPlanType) return;
        this.getAnalyzeInfo();
    }

    getAnalyzeInfo() {
        const params = { ...this.props.params, planTypeId: this.props.selectedPlanType };
        const automaticLoad = isElasticLoad();

        let tareParams = {
            ...params,
            is_tareload: true
        }

        if (!isUUID(params.crewId) && (!automaticLoad || isPlannedOrTodate(params.range))) {
            this.props.actions.clearAnalyzeData();
            this.props.actions.unsubscribeAnalyzeKPI(params);
            this.props.actions.subscribeAnalyzeKPI(params);
        }
        else {
            this.props.actions.clearAnalyzeData(); 
            if(params.showTareLoad) {
                this.props.actions.getTruckLoad(tareParams);
            } else {
                this.props.actions.getTruckLoad(params);
            }
            this.props.actions.subscribeAnalyzeKPI(params);
        }

        if (params.egId && !params.showTareLoad) this.props.actions.getSpeed(params);
    }

    componentWillUnmount() {
        this.props.actions.unsubscribeAnalyzeKPI();
        this.props.actions.clearAnalyzeData();
    }

    render() {
        return <SummaryTwo
            params={this.props.params}
            load={this.props.loadInfo}
            workedKPI={this.props.workedKPI}
            speed={this.props.speed}
            settings={this.props.settings}
        />;
    }
}

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({
        getTruckLoad, clearAnalyzeData, getSpeed,
        subscribeAnalyzeKPI, unsubscribeAnalyzeKPI
    }, dispatch)
});

const mapStateToProps = state => ({
    settings: state.user.settings,
    loadInfo: state.analyze.loadInfo,
    speed: state.analyze.speed,
    selectedPlanType: state.plan.selectedPlanType,
    workedKPI: { isRequesting: state.analyze.elastic.isRequesting }
});

export default connect(mapStateToProps, mapDispatchToProps)(AnalyzeInfoTwo);